import React from "react";
import { Element } from "react-scroll";
import AboutStyles from "./AboutContainer.module.css";
import ProfilePhoto from "../Assests/profile-image.jpg";
import Praveen from "../Assests/profile.png";

const AboutContainer = () => {
  return (
    <Element name="about" className={AboutStyles.aboutContainer}>
      <div className={AboutStyles.aboutContainer_image}>
        <img src={Praveen} alt="" />
      </div>
      <div className={AboutStyles.aboutContainer_getMeKnow}>
        <div className={AboutStyles.aboutContainer_getContent}>
          <h2>ABOUT</h2>
          <h4>Get to know me!</h4>
          <div className={AboutStyles.content_container}>
            <p className={AboutStyles.content}>
              A Passionate Data Scientist, actively pursuing roles in Data
              Science and Software Development to apply passion and expertise in
              extracting insights for informed decision-making
            </p>
            <p className={AboutStyles.content}>
              Microsoft Certified Data Scientist, skilled in model selection,
              Optimization, Hyperparameter Tunning, Model Creation and
              application deployment.
            </p>
            <p className={AboutStyles.content}>
              Extensive background in ML and NLP projects, successfully deriving
              insights and providing recommendations for
              effective problem-solving
            </p>
            <p className={AboutStyles.content}>
              Actively seeking employment opportunities to not only apply
              existing expertise but also expand skills in the AI field,
              contributing to cutting-edge advancements and solutions
            </p>
            <div className={AboutStyles.contacts}>
              <div className={AboutStyles.email}>
                <a href="mailto:code.praveendev@gmail.com">
                  <i className="fa-solid fa-envelope"></i>
                  <span>code.praveendev@gmail.com</span>
                </a>
              </div>
              <div className={AboutStyles.mobile}>
                <a href="tel:+919344639805">
                  <i className="fa-solid fa-phone"></i>
                  <span>+91 9344639805</span>
                </a>
              </div>
            </div>
            <div className={AboutStyles.education}>
              <h4>Education</h4>
              <h2>B.E Computer Science Engineering</h2>
              <h5>Global Institute of Engineering and Technology</h5>
              <h5>Vellore, Tamil Nadu, India</h5>
            </div>
          </div>
        </div>
      </div>
    </Element>
  );
};

export default AboutContainer;
